import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {DEFAULT_LIMIT} from "../contstants";

const useData = (onGetData, onDeleteData, initialPerPage = DEFAULT_LIMIT) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [data, setData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [loadingData, setLoadingData] = useState(true);
    const [pageCount, setPageCount] = useState(null);
    const [newItemAdded, setNewItemAdded] = useState(false);
    const [itemUpdated, setItemUpdated] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showEditItem, setShowEditItem] = useState(false);
    const [showCreateItem, setShowCreateItem] = useState(false);
    const [showViewItem, setShowViewItem] = useState(false);
    const [showDeleteItem, setShowDeleteItem] = useState(false);
    const [itemDeleted, setItemDeleted] = useState(false);
    const [selectedForDelete, setSelectedForDelete] = useState(null);
    const [deleteErrorMessage, setdeleteErrorMessage] = useState(null);
    const [deleteLoading, setdeleteLoading] = useState(false);

    const queryParams = {};
    searchParams.forEach((value, key) => {
        queryParams[key] = value;
    });

    const perPage = queryParams.per_page ? queryParams.per_page : initialPerPage;
    const isSearchbyprn = location.pathname.includes('searchorder'); // Check if the current path includes 'searchorder'

    const requestData = async () => {
        try {
            setLoadingData(true);
            setData(await onGetData(perPage, queryParams, isSearchbyprn));
            setErrorMessage('');
            setLoadingData(false);
        } catch (err) {
            setErrorMessage(err.message);
            setLoadingData(false);
            // console.log("Error fetching data: " + err);
        }
    }

    const deleteItem = async () => {
        try {
            setdeleteLoading(true);
            setdeleteErrorMessage(null);
            const response = await onDeleteData(selectedForDelete);
            if (response.error) {
                setItemDeleted(true);
                setdeleteLoading(false);
                setdeleteErrorMessage(`Error deleting item: ${response.error.message || response.message}`);
                return;
            }
            setData(await onGetData(perPage, queryParams, isSearchbyprn));
            setItemDeleted(true);
            setShowDeleteItem(false);
            setdeleteLoading(false);
            setShowCreateItem(false);
        } catch (err) {
            setdeleteLoading(false);
            setdeleteErrorMessage(err.data.message || err.message);
        }
    };

    useEffect(() => {
        requestData();
    }, [location]);

    useEffect(() => {
        if (newItemAdded || itemUpdated || itemDeleted) {
            requestData();
        }
    }, [newItemAdded, itemUpdated, itemDeleted]);

    useEffect(() => {
        if (data.count && perPage) {
            setPageCount(Math.ceil(data.count / perPage));
        }
    }, [data]);

    return {
        data,
        queryParams,
        refreshData: requestData,
        errorMessage,
        loadingData,
        pageCount,
        newItemAdded,
        setNewItemAdded,
        itemUpdated,
        setItemUpdated,
        selectedItem,
        setSelectedItem,
        showEditItem,
        setShowEditItem,
        showCreateItem,
        setShowCreateItem,
        itemDeleted,
        showDeleteItem,
        setShowDeleteItem,
        setItemDeleted,
        selectedForDelete,
        setSelectedForDelete,
        deleteItem,
        showViewItem,
        setShowViewItem,
        setdeleteErrorMessage,
        deleteErrorMessage,
        setdeleteLoading,
        deleteLoading
    };
}

export default useData;
